import { A } from '@works-web/settings/modules/browser';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '~/settings/__modules__/component';
import {
  CommonService,
  UserOptionName,
} from '~/settings/service/CommonService';

export function AutoReplyExternal() {
  const { t } = useTranslation();
  let enable = false;
  let option = CommonService.getOptionValue(UserOptionName.Auto_Reply);
  if (option) {
    try {
      // 兼容3.0服务器返回的数据
      if (
        option.indexOf('status') > -1 &&
        option.indexOf('enable') === -1 &&
        option.indexOf('timeSettings') === -1
      ) {
        option = option.replace(/\n/g, '\\n').replace(/\r/g, '\\r');
      }
      option = JSON.parse(option);

      // 兼容3.0服务器代码（3.1无status属性）
      enable = option.status || option.enable;
    } catch (e) {
      // empty
      console.error(e);
    }
  }

  return (
    <li className="item has_link">
      <div className="title_area">
        <h4 className="title">
          <span className="text">{t('talk_main_replytitle')}</span>
          <Tooltip>{t('talk_main_tooltip4')}</Tooltip>
        </h4>
      </div>
      <span className="status">
        {enable ? t('talk_main_replystatus1') : t('talk_main_replystatus2')}
      </span>
      <A href="/settings/autoreply" className="link_more">
        <i className="blind">Go to detail</i>
      </A>
    </li>
  );
}
